export default {
  login: {
    method: 'post',
    url: '/v1/system/login'
  }
}
